import { ScreenSize } from './constants';

/** Creates a CSS expression which responsively interpolates a pixel size between two values:
 * one for screens "small" or lower, one for screens "large" or higher.
 *
 * While JS is used to build the CSS expression initially, the interpolation is all CSS.
 *  */
export const responsiveInterpolate = (lowPx: number, highPx: number) =>
  screenTween(ScreenSize.SMALL, ScreenSize.LARGE, lowPx, highPx);

const screenTween = (
  lowScreen: ScreenSize,
  highScreen: ScreenSize,
  lowValue: number,
  highValue: number,
) => {
  void null;
  const rate = (highValue - lowValue) / (highScreen - lowScreen);
  const offset = lowValue - rate * lowScreen;
  return `clamp(${lowValue}px, ${100 * rate}vw + ${offset}px, ${highValue}px)`;
};
